// This is intended to hold types required for communication between reports and
// other apps/domains. If this file grows considerably, consider splittin it into smaller files
// and moving all the types to separate directory

export enum ReportsAppKind {
  Hr = 'hr',
  Ats = 'ats',
}

export interface TellentReportsEnvironment {
  reportsApiUrl: string;
}
